<template>
  <Modal v-model="modal" :mask-closable="false" :footer-hide="true" @on-cancel="cancel" width="360px" class="change">
    <div class="couponmodal">
      <div v-if="!status">
        <h2>{{$t('title.w44')}}</h2>
        <Row class="desc">
          <Col span="8">
            <p>{{$t('label.w103')}}</p>
            <p>{{$t('label.w132')}}</p>
            <p>{{$t('label.w133')}}</p>
            <p>{{$t('label.w134')}}</p>
          </Col>
          <Col span="16">
            <p v-show="coupondata.Type==1">{{$t('option.w59').replace('{%}',coupondata.Rate)}}</p>
            <p v-show="coupondata.Type==2">{{$t('option.w54').replace('{%}',coupondata.Rate)}}</p>
            <p v-show="coupondata.Type==3">{{$t('option.w60').replace('{%}',coupondata.Amount)}}</p>
            <p>{{coupondata.Type==2?$t('option.w61') :$t('option.w62')}}</p>
            <p v-show="coupondata.Type==3">{{$t('other.w83').replace('{%}',coupondata.InvestAmount)}}</p>
            <p v-show="coupondata.Type!=3">{{coupondata.Description}}</p>
            <p>{{$t('other.w85').replace('{%}',coupondata.Days)}}</p>
          </Col>
        </Row>
        <!-- <Button
          @click="exchange(coupondata.Id)"
          :style="{marginLeft:'40px'}"
        >{{coupondata.NeedIntegralCount}}{{$t('btn.b35')}}</Button> -->
        <Button
          @click="exchange(coupondata.Id)"
          :style="{marginLeft:'40px'}"
          :disabled=disabled
        >{{disabled?$t('msg.m90').replace('{%}',differ):`${coupondata.NeedIntegralCount}${$t('btn.b35')}`}}</Button>
      </div>
      <!-- 兑换成功 -->
      <div v-if="status" class="success">
        <p class="t1">{{$t('msg.m91')}}</p>
        <p class="t2">{{$t('msg.m92')}}</p>
        <Button @click="go()">{{$t('btn.b34')}}</Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { clearTimeout } from "timers";
export default {
  props: ["coupondata"],
  data() {
    return {
      status: false,
      modal: false
    };
  },
  methods: {
    exchange(id) {
      this.$axios
        .post("/Member/RZJProfile/IntegralExchangeCoupon", {
          couponId: id
        })
        .then(res => {
          if (res.err) return res.throw();
          this.status = true;
          this.$store.dispatch("user/getUser", "all")
        });
    },
    go() {
      this.modal = false;
      let time = setTimeout(() => {
        this.$router.push({
          name: "coupon"
        });
      }, 100);
    },
    cancel(){
      this.status = false;
    }
  },
  computed:{
    assets(){
      return this.$store.state.user.assets
    },
    disabled(){
      return this.assets.IntegralCount-this.coupondata.NeedIntegralCount>0?false:true
    },
    differ(){
      return this.coupondata.NeedIntegralCount-this.assets.IntegralCount
    }
  },
  destroyed() {
    window.clearTimeout(this.time);
  }
};
</script>

<style lang="less" scoped>
.change {
  /deep/.ivu-modal-content {
    width: 360px;
    height: 431px;
    background: url("../../assets/assetcenter/card_exbg@2x.png") no-repeat;
    background-size: cover;
    .ivu-modal-close {
      top: 40px;
      right: 30px;
    }
  }
}
.couponmodal {
  color: #fff;
  h2 {
    text-align: center;
    margin: 40px 0 50px 0;
  }
  .desc {
    padding-left: 40px;
    font-size: 14px;
    p {
      margin-bottom: 20px;
    }
  }
  .success {
    width: 200px;
    margin: 0 auto;
    text-align: center;
    .t1 {
      font-weight: 600;
      font-size: 32px;
      margin-top: 90px;
    }
    .t2 {
      margin-bottom: 16px;
      opacity: 0.7;
    }
  }
  /deep/.ivu-btn {
    width: 200px;
    height: 40px;
    background: rgba(101, 211, 255, 1);
    border-radius: 25px;
    margin: 40px 0 0 0;
    color: #fff;
  }
}
</style>
